import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkDesignTypeByUsage } from '../../../lib/MyDesignParser';
import { replaceAllSpaces } from '../../../lib/utils';
import { MyDesign } from '../../../models/MyDesign';
import { MyDesignCanvas } from '../MyDesignCanvas';

export const MyDesignDetail: React.FC<{ myDesign: MyDesign; hasMenu?: boolean }> = ({
  myDesign,
  hasMenu
}) => {
  const { t } = useTranslation('my_design');
  const { title, creator, paletteColors, colorData, designType, usage } = myDesign;
  const canvasSize = window.matchMedia('(min-width: 370px)').matches ? 160 : 120;
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 4px 0 0;
      `}
      aria-hidden={!hasMenu}
    >
      <MyDesignCanvas {...{ designType, paletteColors, colorData, usage, canvasSize }} />
      <label
        className={css`
          color: #4d3906;
          font-size: 20px;
          margin: 12px 0 0;
        `}
      >
        {replaceAllSpaces(title)}
      </label>
      {/* eslint-disable-next-line */}
      {usage != undefined && checkDesignTypeByUsage(usage) === 'pro' ? (
        <label
          className={css`
            font-size: 14px;
            color: #9c9c9c;
            margin: 6px 0 0;
          `}
        >
          {t(`usage_00${usage}`)}
        </label>
      ) : (
        undefined
      )}
      <label
        className={css`
          font-size: 16px;
          color: #938666;
          margin: 16px 0 48px;
        `}
      >
        {replaceAllSpaces(creator)}
      </label>
    </div>
  );
};
